/* eslint-disable camelcase */
import { trackClick, trackPage } from ".";
import ChaptersEnum from "./enums/chapters";
import LevelsEnum from "./enums/levels";
import ClickTypes from "./enums/click-types";
import ClicksEnum from "./enums/clicks";

export function trackClickHelp(page_chapter2?: string) {
  return trackClick({
    click_type: ClickTypes.Navigation,
    click: ClicksEnum.Help,
    click_chapter1: ChaptersEnum.Registration,
    click_chapter2: page_chapter2,
    site_level2: LevelsEnum.Registration,
  });
}

export function trackClickEmail(page_chapter2?: string) {
  return trackClick({
    click_type: ClickTypes.Navigation,
    click: ClicksEnum.Email,
    click_chapter1: ChaptersEnum.Registration,
    click_chapter2: page_chapter2,
    site_level2: LevelsEnum.Registration,
  });
}

export function trackStepRegister(page: string, page_chapter1?: string, error?: string) {
  return trackPage({
    page,
    page_chapter1: page_chapter1 || ChaptersEnum.Registration,
    page_chapter2: error,
    site_level2: LevelsEnum.Registration,
  });
}

export function trackClickRegister(
  clickName: string,
  click_chapter1 = "",
  click_chapter2 = "",
  click_chapter3 = "",
) {
  return trackClick({
    click_type: ClickTypes.Navigation,
    click: clickName,
    click_chapter1: click_chapter1 || ChaptersEnum.Registration,
    click_chapter2: click_chapter2,
    click_chapter3: click_chapter3,
    site_level2: LevelsEnum.Registration,
  });
}
